var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0833 45.8333H17.9167C14.7917 45.8333 12.0833 43.5417 11.6667 40.4167L8.54167 14.1667C8.33333 13.3333 9.16667 12.5 10 12.5H40.2083C41.0417 12.5 41.6667 13.3333 41.6667 14.1667L38.3333 40.4167C37.7083 43.5417 35.2083 45.8333 32.0833 45.8333Z",
    fill: "#FFD2CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 8.33333H16.6667V6.25C16.6667 5 17.5 4.16666 18.75 4.16666H31.25C32.5 4.16666 33.3333 5 33.3333 6.25V8.33333Z",
    fill: "#E85048"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5833 6.25C38.3333 6.25 11.6667 6.25 10.4167 6.25C8.125 6.25 6.25 8.125 6.25 10.4167C6.25 12.7083 8.125 14.5833 10.4167 14.5833C11.6667 14.5833 38.3333 14.5833 39.5833 14.5833C41.875 14.5833 43.75 12.7083 43.75 10.4167C43.75 8.125 41.875 6.25 39.5833 6.25Z",
    fill: "#E85048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.bb82cc31c9787b6e36930b915849978c.svg";
export { ForwardRef as ReactComponent };